module.exports = __webpack_public_path__ + "img/baseball.7f28346f.svg";